import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
import { ordinal } from '../../helper';

function OrderedResults(props) {
  const { data } = props;
  const { datasets } = data;
  const rankings = datasets?.[0]?.percentages ? Object.keys(datasets?.[0]?.percentages) : [];
  const columnArray = [
    { Header: 'Priority', accessor: 'priority' },
    { Header: 'Answer Option', accessor: 'label', width: false },
    ...rankings.map((ranking, index) => ({
      Header: ordinal(ranking),
      accessor: `values[${index}]`,
      width: false,
    })),
    { Header: 'Total', accessor: 'total', width: false },
    { Header: 'Score', accessor: 'score', width: false },
  ];
  const tableData = datasets.map((dataset) => ({
    label: dataset.label,
    values: rankings.map((_, index) => (
      <>
        {dataset.percentages[index]}%<br />
        {dataset.counts[index]}
      </>
    )),
    total: dataset.total,
    score: dataset.score,
    rankedFirstCount: dataset.counts[1],
    priority: dataset.priority,
  }));

  // sort table by priority
  tableData.sort((lhsData, rhsData) => {
    if (lhsData.score === rhsData.score) {
      return lhsData.rankedFirstCount > rhsData.rankedFirstCount ? -1 : 1;
    }
    return lhsData.score > rhsData.score ? -1 : 1;
  });

  // add priority labels
  tableData.forEach((_, index) => {
    if (index === 0) {
      tableData[index].priority = 1;
    } else {
      const currentScore = tableData[index].score;
      const previousScore = tableData[index - 1].score;
      const currentRankedFirstCount = tableData[index].rankedFirstCount;
      const previousRankedFirstCount = tableData[index - 1].rankedFirstCount;
      const previousPriority = tableData[index - 1].priority;
      if (currentScore === previousScore && currentRankedFirstCount === previousRankedFirstCount) {
        // should be same as previous rank
        tableData[index].priority = previousPriority;
      } else {
        // increment by one
        tableData[index].priority = previousPriority + 1;
      }
    }
  });

  return (
    <div className="engage-results-ordered-results">
      <h4 className="engage-results-engagement-screen__chart-content__subtitle">Results</h4>
      <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} />
    </div>
  );
}

OrderedResults.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        percentages: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
        counts: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
        image: PropTypes.string,
      }).isRequired
    ).isRequired,
  }).isRequired,
};

export default OrderedResults;
